// extracted by mini-css-extract-plugin
export default {"InfoActionHeader":"InfoActionHeader_InfoActionHeader__qjzNM","InfoBlock":"InfoActionHeader_InfoBlock__O+-1R"};